export const parseWorkerErrorBody = (rawBody) => {
    const text = String(rawBody || '').trim();
    if (!text) return { text: '', data: null };
    try {
        return { text, data: JSON.parse(text) };
    } catch {
        return { text, data: null };
    }
};

export const buildWorkerErrorDetails = (response, parsedBody) => {
    const errorPayload = parsedBody?.data || null;
    const rawText = parsedBody?.text || '';
    const extractedMessage = errorPayload?.error
        || errorPayload?.message
        || errorPayload?.details
        || errorPayload?.error?.message
        || rawText
        || response.statusText
        || 'Unknown error';

    const status = Number(response.status) || null;
    const retryAfterHeader = response.headers?.get?.('retry-after');
    const retryAfter = errorPayload?.retry_after
        ?? errorPayload?.metadata?.retry_after
        ?? (retryAfterHeader ? Number.parseInt(retryAfterHeader, 10) : null);
    const normalizedRetryAfter = Number.isFinite(retryAfter) ? retryAfter : null;

    return {
        status,
        statusText: response.statusText || null,
        message: String(extractedMessage),
        code: errorPayload?.code || errorPayload?.error?.code || null,
        remaining: Number.isFinite(errorPayload?.remaining) ? errorPayload.remaining : null,
        limit: Number.isFinite(errorPayload?.limit) ? errorPayload.limit : null,
        retry_after: normalizedRetryAfter,
        raw: rawText || null
    };
};

